export const socialsData = {
    github: 'https://github.com/RizkyPratamaHidayat?tab=repositories',
    facebook: '',
    linkedIn: 'https://www.linkedin.com/in/eki-hie-3b294b1a1',
    instagram: '',
    codepen: '',
    twitter: '',
    reddit: '',
    blogger: '',
    medium: '#',
    stackOverflow: '',
    gitlab: '',
    youtube: ''
}